<script lang="ts">
	import { PodcastEpisodePage } from '#lib/websites/talks/pages/PodcastEpisodePage/index.js';
</script>

<PodcastEpisodePage />
